import { HelpCenterError } from '../../types';
import moreInformationNeeded from './moreInformationNeeded.svg';
import noArticles from './noArticles.svg';

type svgImage = string;

export const helpCenterErrorToPrefixMap: Record<HelpCenterError, string> = {
  [HelpCenterError.MORE_INFORMATION_NEEDED]:
    'error_page_more_information_needed',
  [HelpCenterError.NO_ARTICLES]: 'error_page_no_articles',
};

export const helpCenterErrorToImage: Record<HelpCenterError, svgImage> = {
  [HelpCenterError.MORE_INFORMATION_NEEDED]: moreInformationNeeded,
  [HelpCenterError.NO_ARTICLES]: noArticles,
};
